import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE,
         CANCEL,
         Video_deleted} from './../../../../app.constant';

@Component({
  selector: 'app-product-video',
  templateUrl: './product-video.component.html',
  styleUrls: ['./product-video.component.scss'],
})
export class ProductVideoComponent implements OnInit {
  @Input() data: any[];

  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {}

  getVideos = () => {
    this.apiService.getData(Urls.getProductVideo).subscribe((response: any) => {
      this.data = response.data.videoList;
    });
  };

  onEdit(obj: any) {
    this.editChange.emit(obj);
    this.scrollTop();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  deleteData = (id) => {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteProductVideo, { id })
            .subscribe((response: any) => {
              console.log(response);
              this.getVideos();
            });
          this.toastr.success(Video_deleted);
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };
}
